import { theme, darken } from '@salecycle/ui-component-library';
import styled from 'styled-components';

export const LayoutWithStaticSidePanelRight = styled.div`
  width: 100%;
`;

export const TemplatesGridWrapper = styled.div`
  padding-left: 70px;
  padding-right: 115px;

  @media (min-width: 1750px) {
    padding-right: 60px;
    padding-left: 50px;
  }
`;

export const SidePanelWrapper = styled.nav`
  position: fixed;
  right: 0;
  top: 50px;
  z-index: 1000;
  min-width: 300px;
  max-width: 300px;
  overflow: scroll;
  height: calc(100vh - 50px);
  padding-bottom: 30px;
  background: ${theme.vars.newColor.white};
  transform: translateX(100%);
`;

export const PanelContainer = styled.div`
  min-width: 0;
  width: 100%;

  &.selected {
    height: calc(100% - 230px);
  }
  .selectedTemplateContainer {
    display: none;
    position: relative;
  }

  &:hover,
  &.selected {
    .selectedTemplateContainer {
      display: block;
    }
  }
`;

export const TemplateContainer = styled.button<{ isSelected?: boolean }>`
  border-radius: 5px;
  border: ${theme.vars.newColor.lightGS1} 1px solid;
  height: 230px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: ${theme.vars.transition.default};
  background-color: ${theme.vars.newColor.white};

  ${props =>
    props.isSelected &&
    `
    border: 2px solid ${theme.vars.newColor.blue2};
    background-color: rgba(204, 227, 255, 0.15);
    box-shadow: 0 2px 8px rgba(204, 227, 255, 0.4);
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const SelectedTemplateInner = styled.div`
  display: none;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: center;
`;

export const OptionsContainer = styled.div`
  display: flex;
  border-top: 1px dashed ${theme.vars.newColor.darkGS3};
  padding: 5px;
  justify-content: center;
  align-items: center;
`;

export const Label = styled.div`
  margin-top: 20px;
  font-size: 16px;
  font-weight: 600;
  padding-bottom: 5px;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

export const SubLabel = styled.div`
  color: ${theme.vars.newColor.darkGS2};
  overflow-wrap: anywhere;
  word-break: break-word;
`;

// Create Panel
export const CreateButtonContainer = styled.div`
  background-color: ${theme.vars.newColor.lightGS2};
  border-radius: 5px;
  border: ${theme.vars.newColor.lightGS1} 1px solid;
  height: 230px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${darken(0.02, theme.vars.newColor.lightGS2)};
    cursor: pointer;
  }
`;
export const CreateLabel = styled.div`
  margin-top: 20px;
  font-size: 16px;
  color: #93abbc;
  font-weight: 600;
`;

export const CreateIconCircle = styled.div`
  display: flex;
  width: 69px;
  height: 69px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #f9fbfd;
  box-shadow: 2px 3px 4px 1px #c7c4c4;
`;

// Sidebar components
export const Sidebar = styled.div`
  padding: 2rem;
`;

export const SidebarSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const SidebarSectionTitle = styled.div`
  font-size: 20px;
  color: ${theme.vars.color.pink};
  flex: 1;
`;

export const SidebarSectionSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${theme.vars.newColor.darkGS1};
`;

export const Text = styled.span`
  color: ${theme.vars.newColor.darkGS2};
  font-size: 14px;
  margin-right: 5px;
`;
interface IProps {
  clickable?: boolean;
}
export const BlueText = styled.span<IProps>`
  color: ${theme.vars.newColor.blue1};
  font-size: 14px;
  cursor: ${props => (props.clickable ? 'pointer' : 'default')};
`;

export const TemplateButton = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: white;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  height: 40px;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  gap: 10px;
  border-radius: 4px;
  box-shadow: 0px 2px 6px
    ${({ backgroundColor }) => {
      // Convert hex to rgba for shadow with opacity
      if (backgroundColor.startsWith('#')) {
        const hex = backgroundColor.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, 0.2)`;
      }
      // If already rgba/rgb, extract and add opacity
      const rgbaMatch = backgroundColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
      if (rgbaMatch) {
        return `rgba(${rgbaMatch[1]}, ${rgbaMatch[2]}, ${rgbaMatch[3]}, 0.2)`;
      }
      // Fallback
      return `rgba(0, 0, 0, 0.15)`;
    }};
  width: 236px;
  white-space: nowrap;

  :hover {
    filter: brightness(${({ onClick }) => (onClick ? '120' : '100')}%);
  }
`;
